<template>
    <section class="sports-window">
        <div class="wrap">
            <div class="new-close" @click="changeState('sports_new')">
                <img src="@/assets/images/icons/icon_close.svg">
            </div>
            <div class="input-search">
                <input type="search" placeholder="Поиск" v-model="search">
                <img src="/img/search.6d7a391a.svg" width="22px">
            </div>
            <div class="sports-window-body">
                <Sports :new="true" v-if="sports" :sports="filteredSports" :type="'all'" />
            </div>
            <div class="sports-window-new">
                <p>Или предложите свой вид спорта</p>
                <input type="text" v-model="new_category" @keydown.enter="newCategory()"/>
            </div>
        </div>
        <div class="sports-window__button button" @click="changeState('sports_new')" v-if="getActiveSports.length > 0">Добавить категории</div>
    </section>
</template>
<script>
export default {
    name: 'sports_new',
    components: {
        Sports: () => import('@/components/Filters/SportsNew.vue')
    },
    data () {
        return {
            sports: null,
            new_category: null,
            search: null
        }
    },
    computed: {
        getActiveSports () {
            return this.$store.getters.getActiveSportsNew
        },
        filteredSports() {
            return this.search 
                ? this.sports.filter(sport => sport.ru.toUpperCase().indexOf(this.search.toUpperCase()) !== -1 )
                : this.sports
        }
	},
    methods: {
        async fetchSports () {
            this.sports = await this.$store.dispatch('fetchSports');
        },
        newCategory () {
            let upperText = this.new_category.toUpperCase();
            upperText.length < 26 && upperText.length > 2 ? this.sendNewCategory(upperText) : this.$store.dispatch('addError', { message: 'Не подходящий размер сообщения' });
        },
        async sendNewCategory(title) {
            await this.$store.dispatch('sendNewCategory', {title})
                .then(() => {
                    this.new_category = null
                    this.$store.dispatch('addNotification', { message: 'Спасибо! Я рассмотрю ваше предложение 😎' });
                });
        },
        changeState (element) {
            this.$store.dispatch('changeState', {element: element, val: false})
        }
    },
    mounted() {
        this.fetchSports()
    }
}
</script>